
export class ContactMessage {

	public id: string;
	public contactReasonId: number;
	public message: string;
	public ipAddress: string;
	public timeStamp: Date;
	public name: string;
	public email: string;
	public page: string;

}
